export default __webpack_public_path__ + "static/media/coolCar.e65fa543.jpg";